import I18n from 'I18n';
import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
// @ts-expect-error Untyped import
import { splitConfig } from 'reporting-data/compare';
import { DEFAULT_FISCAL_YEAR_MONTH_NAME } from 'reporting-data/constants/dates';
// @ts-expect-error Untyped import
import { formatDate } from 'reporting-data/hydrate/propertyFormatter';
import { getUseFiscalYear } from 'reporting-data/lib/fiscalYearUtils';
import { Metrics } from 'reporting-ui-components/monitoring/Metrics';
import { INLINE_COMPARISON_LABEL_INTERACTION, INLINE_COMPARISON_LABEL_RENDERED } from '../../constants/trackingMetrics';
// @ts-expect-error Untyped import
import { getCompareLabel } from '../../lib/compare-options';
import { FiscalYearContext } from '../PlatformReport/FiscalYearProvider';
// @ts-expect-error Untyped import
import { ConditionalLabel, Label } from './Label';
import { StandardInlineLabel } from './labelComponents/StandardInlineLabel';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
const dateFormat = 'll';
const getComparePeriodValue = config => config.get('compare');
const getOriginalDateRange = config => config.getIn(['filters', 'dateRange', 'value']);
export const condition = ({
  config
}) => config && !!getComparePeriodValue(config) && !!getOriginalDateRange(config);
export const getComparisonRangeText = (config, fiscalYearMonthName = DEFAULT_FISCAL_YEAR_MONTH_NAME) => {
  const {
    compareConfig
  } = splitConfig(config, fiscalYearMonthName);
  const {
    startDate,
    endDate
  } = compareConfig.getIn(['filters', 'dateRange', 'value']).toJS();
  if (startDate === endDate) {
    return `${formatDate(startDate, dateFormat)}`;
  }
  return `${formatDate(startDate, dateFormat)} - ${formatDate(endDate, dateFormat)}`;
};
const logUsage = event => {
  const isHovered = event.target.value;
  if (isHovered) {
    Metrics.counter(INLINE_COMPARISON_LABEL_INTERACTION).increment();
  }
};
export const render = Label(({
  config,
  use
}) => {
  const useFiscalYear = getUseFiscalYear(config);
  const fiscalYearMonthName = useContext(FiscalYearContext);
  useEffect(() => {
    Metrics.counter(INLINE_COMPARISON_LABEL_RENDERED).increment();
  }, []);
  return /*#__PURE__*/_jsx(StandardInlineLabel, {
    tooltipProps: {
      headingText: I18n.text('reporting-ui-components.report-inline-labels.datesIncluded'),
      title: getComparisonRangeText(config, fiscalYearMonthName),
      onOpenChange: event => logUsage(event)
    },
    inlineLabelBadgeText: /*#__PURE__*/_jsx(Small, {
      use: use,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingLabels.compareV2.inlineLabel",
        options: {
          comparePeriodLabel: getCompareLabel({
            dateRange: getOriginalDateRange(config),
            explicit: false,
            value: getComparePeriodValue(config),
            useFiscalYear
          })
        }
      })
    }),
    dataTestId: "inline-comparison-label-v2"
  });
});
export const renderWithCondition = ConditionalLabel(condition, render);
export const __TESTABLE__ = {
  getComparisonRangeText
};